import React from 'react'

function Reading() {
    return (
        <div>Reading</div>
    )
}

export default Reading